import { Link } from 'react-router-dom';
import { hotDramas } from '@/mocks/dramas';

export default function HotDramas() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热播推荐
          </h2>
          <p className="text-sm text-foreground-600 mt-2">本周最受欢迎的剧集，大家都在追</p>
        </div>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap flex items-center gap-1"
        >
          查看全部 <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
        {hotDramas.slice(0, 5).map((drama) => (
          <Link
            key={drama.id}
            to={`/article/${drama.id}`}
            className="group cursor-pointer"
          >
            <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3">
              <img
                src={drama.posterUrl}
                alt={drama.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2 py-1 bg-accent-500 text-white text-xs font-semibold rounded-md">
                  {drama.rating}
                </span>
              </div>
              {drama.isNew && (
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-md">
                    NEW
                  </span>
                </div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <p className="text-white text-xs leading-relaxed line-clamp-3">{drama.description}</p>
              </div>
            </div>
            <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
              {drama.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-1">
              {drama.category} · {drama.episodes}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}